import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Flex, Box, Text, TextInput, Select } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useStyles } from "./style";
import {
  addSkypointProjectTask,
  updateSkypointProjectTask,
} from "../../services/skypointProject";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import {
  addSkypointProspectStatus,
  getAllSkypointProspectsStatus,
} from "../../services/skypointProspect";

const ProspectStatusModal = ({ opened, onClose }) => {
  const { classes } = useStyles();
  const [formData, setFormData] = useState({
    ProspectStatus: "",
    category: "open",
  });

  // validation errors object
  const [errors, setErrors] = useState({});

  // loading state for submit
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const validation = validateForm();
    if (!validation.valid) {
      setErrors(validation.errors);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
      };

      const res = await addSkypointProspectStatus(payload);
      await getAllSkypointProspectsStatus();
      res && handleCancel();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      ProspectStatus: "",
      category: "open",
    });

    setErrors({});

    onClose();
  };

  const validateForm = () => {
    const errs = {};

    if (
      !formData.ProspectStatus ||
      formData.ProspectStatus.toString().trim() === ""
    ) {
      errs.ProspectStatus = "status is required";
    }

    return { valid: Object.keys(errs).length === 0, errors: errs };
  };

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title={
        <Text size="lg" weight={700} style={{ fontFamily: "Inter" }}>
          Add Status
        </Text>
      }
      size="xl"
      centered
      zIndex={1000}
      padding={0}
      styles={{
        root: classes.root,
        inner: classes.inner,
        modal: classes.modal,
        header: classes.header,
        body: classes.body,
        close: classes.close,
      }}
      closeButtonProps={{
        icon: <IconX size={20} />,
      }}
    >
      <Box p="xl" className={classes.mainContent}>
        <Box className={classes.formContainer}>
          <Box mb="md">
            <TextInput
              placeholder="Enter status"
              value={formData.ProspectStatus}
              onChange={(e) => {
                setFormData({ ...formData, ProspectStatus: e.target.value });
                setErrors((p) => ({ ...p, ProspectStatus: undefined }));
              }}
            />
            {errors.ProspectStatus && (
              <Text size="xs" color="red" mt={6}>
                {errors.ProspectStatus}
              </Text>
            )}
          </Box>

          <Box mb="md">
            <Select
              label="Category"
              placeholder="Select category"
              value={formData.category}
              onChange={(value) => {
                setFormData({ ...formData, category: value });
              }}
              data={[
                { value: "open", label: "Open" },
                { value: "converted", label: "Converted" },
                { value: "lost", label: "Lost" },
              ]}
            />
          </Box>

          <Flex gap="md" mt="xl" direction={{ base: "column", xs: "row" }}>
            <Button
              variant="default"
              fullWidth
              size="md"
              onClick={handleCancel}
              className={classes.cancelButton}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              size="md"
              onClick={handleSubmit}
              className={classes.createButton}
              loading={loading}
              disabled={loading}
            >
              Save
            </Button>
          </Flex>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProspectStatusModal;
